import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  login: (data) => API.post('/auth/login', data),
  register: (data) => API.post('/auth/register', data),
  me: () => API.get('/auth/me'),
  updateProfile: (data) => API.put('/auth/profile', data),
  forgotPassword: (data) => API.post('/auth/forgot-password', data),
  resetPassword: (token, data) => API.put(`/auth/reset-password/${token}`, data),
};

// Users
export const userAPI = {
  list: (params) => API.get('/users', { params }),
  get: (id) => API.get(`/users/${id}`),
  create: (data) => API.post('/users', data),
  update: (id, data) => API.put(`/users/${id}`, data),
  delete: (id) => API.delete(`/users/${id}`),
  trainers: () => API.get('/users/trainers/list'),
};

// Courses
export const courseAPI = {
  list: (params) => API.get('/courses', { params }),
  get: (id) => API.get(`/courses/${id}`),
  create: (data) => API.post('/courses', data),
  update: (id, data) => API.put(`/courses/${id}`, data),
  delete: (id) => API.delete(`/courses/${id}`),
  myAsTrainer: () => API.get('/courses/trainer/my-courses'),
};

// Enrollments
export const enrollmentAPI = {
  enroll: (courseId) => API.post('/enrollments', { courseId }),
  all: (params) => API.get('/enrollments', { params }),
  mine: () => API.get('/enrollments/my'),
  updateStatus: (id, status) => API.put(`/enrollments/${id}/status`, { status }),
  trainerStudents: () => API.get('/enrollments/trainer/students'),
  updateProgress: (id, lessonId) => API.put(`/enrollments/${id}/progress`, { lessonId }),
  submitQuiz: (id, answers) => API.post(`/enrollments/${id}/quiz`, { answers }),
};

// Certifications (the templates attached to courses)
export const certificationAPI = {
  list: () => API.get('/certifications'),
  get: (id) => API.get(`/certifications/${id}`),
  getByCourse: (courseId) => API.get(`/certifications/course/${courseId}`),
  create: (data) => API.post('/certifications', data),
  update: (id, data) => API.put(`/certifications/${id}`, data),
  delete: (id) => API.delete(`/certifications/${id}`),
};

// Certificates (the issued ones)
export const certificateAPI = {
  issue: (enrollmentId) => API.post('/certificates/issue', { enrollmentId }),
  all: () => API.get('/certificates'),
  mine: () => API.get('/certificates/my'),
  verify: (certId) => API.get(`/certificates/verify/${certId}`),
  trainerIssued: () => API.get('/certificates/trainer/issued'),
  download: (id) =>
    API.get(`/certificates/${id}/download`, { responseType: 'blob' }),
};

export default API;
